import React, { useEffect, useState } from "react";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { db } from "../../firebase";

const STATES = [
  ["AL", "Alabama"], ["AK", "Alaska"], ["AZ", "Arizona"], ["AR", "Arkansas"],
  ["CA", "California"], ["CO", "Colorado"], ["CT", "Connecticut"], ["DE", "Delaware"],
  ["DC", "District of Columbia"], ["FL", "Florida"], ["GA", "Georgia"], ["HI", "Hawaii"],
  ["ID", "Idaho"], ["IL", "Illinois"], ["IN", "Indiana"], ["IA", "Iowa"],
  ["KS", "Kansas"], ["KY", "Kentucky"], ["LA", "Louisiana"], ["ME", "Maine"],
  ["MD", "Maryland"], ["MA", "Massachusetts"], ["MI", "Michigan"], ["MN", "Minnesota"],
  ["MS", "Mississippi"], ["MO", "Missouri"], ["MT", "Montana"], ["NE", "Nebraska"],
  ["NV", "Nevada"], ["NH", "New Hampshire"], ["NJ", "New Jersey"], ["NM", "New Mexico"],
  ["NY", "New York"], ["NC", "North Carolina"], ["ND", "North Dakota"], ["OH", "Ohio"],
  ["OK", "Oklahoma"], ["OR", "Oregon"], ["PA", "Pennsylvania"], ["RI", "Rhode Island"],
  ["SC", "South Carolina"], ["SD", "South Dakota"], ["TN", "Tennessee"], ["TX", "Texas"],
  ["UT", "Utah"], ["VT", "Vermont"], ["VA", "Virginia"], ["WA", "Washington"],
  ["WV", "West Virginia"], ["WI", "Wisconsin"], ["WY", "Wyoming"],
];

const CONFIG_REF = doc(db, "config", "gamblingStates");

export default function AdminGamblingStates() {
  const [enabled, setEnabled] = useState(new Set(["MN", "WI"]));
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [savedMsg, setSavedMsg] = useState("");

  useEffect(() => {
    (async () => {
      const snap = await getDoc(CONFIG_REF);
      if (snap.exists() && Array.isArray(snap.data().enabledStates)) {
        setEnabled(new Set(snap.data().enabledStates));
      }
      setLoading(false);
    })();
  }, []);

  const toggle = (code) => {
    setEnabled((prev) => {
      const next = new Set(prev);
      if (next.has(code)) {
        next.delete(code);
      } else {
        next.add(code);
      }
      return next;
    });
  };

  const save = async () => {
    setSaving(true);
    setSavedMsg("");
    await setDoc(CONFIG_REF, { enabledStates: Array.from(enabled) }, { merge: true });
    setSaving(false);
    setSavedMsg("Saved!");
    setTimeout(() => setSavedMsg(""), 2500);
  };

  if (loading) {
    return <div style={{ color: "#fff" }}>Loading…</div>;
  }

  return (
    <div style={{ color: "#fff", maxWidth: 720 }}>
      <h2 style={{ marginTop: 0 }}>Gambling / Charitable Gaming — Enabled States</h2>
      <p style={{ color: "#B8B0C8", fontSize: 14, lineHeight: 1.5 }}>
        Only users whose profile state is checked below will see the Pulltabs /
        charitable gaming tab in the app. Charitable gaming laws vary a lot by
        state, so leave a state unchecked unless you've confirmed it's okay to
        show that content there.
      </p>

      <div style={{ display: "flex", gap: "10px", marginBottom: "16px" }}>
        <button
          onClick={() => setEnabled(new Set(["MN", "WI"]))}
          style={btnStyle("#3B2F5C")}
        >
          Reset to MN + WI only
        </button>
        <button onClick={() => setEnabled(new Set())} style={btnStyle("#3B2F5C")}>
          Disable all
        </button>
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(180px, 1fr))",
          gap: "8px",
          background: "#15121F",
          padding: "16px",
          borderRadius: "12px",
          border: "1px solid rgba(255,255,255,0.08)",
        }}
      >
        {STATES.map(([code, name]) => (
          <label
            key={code}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              fontSize: "14px",
              cursor: "pointer",
            }}
          >
            <input
              type="checkbox"
              checked={enabled.has(code)}
              onChange={() => toggle(code)}
            />
            {name} ({code})
          </label>
        ))}
      </div>

      <div style={{ marginTop: "20px", display: "flex", alignItems: "center", gap: "14px" }}>
        <button onClick={save} disabled={saving} style={btnStyle("#A855F7")}>
          {saving ? "Saving…" : "Save Changes"}
        </button>
        {savedMsg && <span style={{ color: "#4ADE80" }}>{savedMsg}</span>}
      </div>
    </div>
  );
}

function btnStyle(bg) {
  return {
    background: bg,
    border: "none",
    padding: "10px 18px",
    borderRadius: "8px",
    color: "#fff",
    fontWeight: 600,
    cursor: "pointer",
    fontSize: "14px",
  };
}
